import type { Order } from "@graphql/generated/types";
import type { IPaymentStrategy } from "@interfaces/payment-method/PaymentStrategy";
import type { PaymentValues } from "@lib/utils/checkoutHelper";
import { getSuccessPayment } from "./payment-method-strategies/amazonPaymentMethodUtils";

export class AmazonResolver {
    private strategies: Map<string, IPaymentStrategy>;

    private defaultPaymentValues: PaymentValues = {
        paymentSystem: null,
        paymentSystemIcon: null,
        paymentReference: null,
        paymentDateOfExpiry: null,
    };
    constructor(strategies: Map<string, IPaymentStrategy>) {
        this.strategies = strategies;
    }

    resolve(order: Order): PaymentValues {
        if (!order?.paymentInfo?.payments) return null;

        // Get successful payment made with Amazon Pay
        const validPayment = getSuccessPayment(order);

        if (!validPayment) {
            return this.defaultPaymentValues;
        }

        return this.strategies.get("amazonDefault").resolve(order);
    }
}
